import { lazy } from 'react';

// Lazy wrapper so react-markdown stays out of the initial bundle. The drawer
// itself isn't code-split, so importing PromptBody directly would pull
// react-markdown into main; this defers it to a chunk loaded when a drawer with
// a prompt first opens. Mirrors RunPage.lazy.ts.
export const PromptBody = lazy(() => import('./PromptBody'));
